import React from 'react'
import styled from 'styled-components'

const Wrapper=styled.div`
display:flex;
border:1px solid ${props=>props.isSelected?'#1B49EA':'#1E222880'};
border-radius:4px;
justify-content:space-between;
align-items:center;
max-width:170px;
height:40px;
color:${props=>props.isSelected?'#1B49EA':'#1E222880'};
font-size:14px;
margin:5px 10px 5px 0;
padding:0 6px;
font-weight:500;
cursor: pointer;

`
const Circle=styled.span`
width:12px;
height:12px;
border-radius:50%;
margin-right:5px;

border: ${props=>props.isSelected?'3px':'1px'} solid ${props=>props.isSelected?'#1B49EA':'#1E222880'};
color:${props=>props.isSelected?'#1B49EA':'#1E222880'};
`

const TeamRadioSelect = ({item,handleChange,selectedValue} ) => {

return(
    <Wrapper onClick={()=> handleChange(item.value) } isSelected={selectedValue===item.value} ><Circle isSelected={selectedValue===item.value} />{item.name} </Wrapper>
  )
}

export default TeamRadioSelect